<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-receipt"></i>
          Vytvoření projektu ze šablony <strong>{{ templateLabel }}</strong>
        </h5>
        <div v-if="$store.getters.currentUserHasAction('EDIT_PROJECT')"
             class="section-title-controls"
        >
          <ActiveButton
            class="asd-btn-confirm"
            :click="createProject"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>
      <div class="asd-form">
        <div class="alert alert-warning">
          <div v-for="(cl, $index) in changeList"
               :key="`cl-${$index}`"
          >
            <strong v-html="cl[0]"></strong> => {{ cl[1] }}
          </div>
        </div>
      </div>

      <div class="asd-form">
        <PropertyForm
          v-if="template"
          :key="`PF-${templateId}-${$store.getters.DLI}`"
          v-model="data.propertyValues"
          class="asd-form"
          :meta="{entityType: templateType}"
          :propertyKeys="templatePropertyKeys"
        ></PropertyForm>
      </div>

      <div class="asd-form">
        <TabbedView style="margin: 10px">
          <template>
            <div :key="`team`"
                 class="tab-content"
            >
              <button class="asd-btn-action"
                      @click="fillTeamToTasks()"
              >
                Vyplnit team z projektu do úkolu
              </button>
            </div>
          </template>
          <template>
            <div :key="`Offset casu`"
                 class="tab-content"
                 style="display: flex"
            >
              <span>
                <input v-model="offsetDays"
                       class="asd-input"
                       type="number"
                       placeholder="dni"
                /> dnů</span>
              <span>
                <input v-model="offsetHours"
                       class="asd-input"
                       type="number"
                       placeholder="hodin"
                /> hodin</span>
              <span>
                <button class="asd-btn-action"
                        @click="timeTodayPlusOffset()"
                >
                  Přepočítat datumy k dnešku plus zadaný offset
                </button>
              </span>
            </div>
          </template>
          <!-- <template>
            <div :key="`Workflow`"
                 class="tab-content"
            >
              <button class="asd-btn-action"
                      @click="resetTasksWorkflow()"
              >
                Nastavit wf pro ukoly na start`
              </button>
            </div>
          </template> -->
          <template>
            <div :key="`Reset`"
                 class="tab-content"
            >
              <button class="asd-btn-action"
                      @click="resetOverrides()"
              >
                Vyresetovat všechny upravené hodnoty úkolů
              </button>
            </div>
          </template>
        </TabbedView>
      </div>
      <div class="asd-form">
        <table class="asd-table">
          <thead>
            <tr class="table-heading">
              <th>
                Název
              </th>
              <th v-for="pts in tasksPropertiesToShow"
                  :key="pts.key"
              >
                {{ pts.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="t in tasks"
                :key="t.id"
            >
              <td>{{ t.label }}</td>
              <td v-for="pts in tasksPropertiesToShow"
                  :key="pts.key"
              >
                <PropertyDetailProxy v-if="t.propertyValues[pts.key]"
                                     :id="pts.key"
                                     :key="pts.key"
                                     :value="t.propertyValues[pts.key]"
                                     :meta="{projectId: templateId}"
                ></PropertyDetailProxy>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyForm from 'CORE/components/form/property-form'
import TemplateDataMixin from 'CORE/mixins/template-data'
import labels from 'CORE/utils/labels'
import PropertyDetailProxy from 'CORE/components/data-type/property-detail-proxy'
import TabbedView from 'CORE/components/tabbed-view/tabbed-view'
import { get, pickBy, map, each, keys, chain, mapValues, uniq, min, cloneDeep, merge } from 'lodash'
import ActiveButton from 'CORE/components/form/active-button'
import { uuid } from 'vue-uuid'
import EventBus from 'CORE/bus'


export default {
    name: 'CreateTemplateForm',
    components: {
        PropertyForm,
        PropertyDetailProxy,
        TabbedView,
        ActiveButton,
    },
    mixins: [
        TemplateDataMixin,
    ],
    data() {
        return {
            data: {},
            templateId: null,
            changeList: [],
            taskStatusFilter: '$all',
            overrides: {},
            offsetDays: 0,
            offsetHours: 0,
        }
    },
    computed: {
        projectTimeProperties() {
            return pickBy(get(this.data, 'propertyValues', {}), (pv, pk) => {
                const pt = this.$store.getters.propertyTypeByKey(pk)
                return pt.type === 'DATE_TIME' || pt.type === 'DATE'
            })
        },
        templatePropertyKeys() {
            return map(get(this.templateType, 'propertyType', {}), pt => pt.key)
        },
        templateLabel() {
            return labels.project(this.template)
        },
        templateTasks() {
            const tasks = this.$store.getters.tasksBy({
                projectId: this.templateId,
                taskStatus: '$all',
            })
            return tasks
        },
        tasksPropertiesToShow() {
            return chain(this.tasks)
                .map(t => keys(get(t, 'propertyValues', {})))
                .flattenDeep()
                .uniq()
                .map(t => {
                    const pt = this.$store.getters.propertyTypeByKey(t)
                    return {
                        key: t,
                        name: pt.name,
                        type: pt.type,
                    }
                })
                .value()
        },
        tasks() {
            return map(this.templateTasks, t => {
                const propertyValues = pickBy(get(t, 'propertyValues', {}), (pv, pk) => {
                    const pt = this.$store.getters.propertyTypeByKey(pk)
                    const systags = get(pt, 'settings.systags', {})
                    if (get(systags, 'assignee', false)) {
                        return true
                    }
                    return pt.type === 'DATE_TIME' || pt.type === 'DATE'
                })
                return {
                    id: t.id,
                    label: labels.task(t),
                    propertyValues: mapValues(propertyValues, (pv, pk) => {
                        if (this.overrides[`${t.id}-${pk}`]) {
                            return this.overrides[`${t.id}-${pk}`]
                        } else if (this.overrides[`${t.id}-${pk}`] === null) {
                            console.info(this.overrides[`${t.id}-${pk}`])
                            return null
                        }
                        return pv
                    }),
                }
            })
        },
        taskKeysForSystag() {
            return (...args) => {
                const assigneeKeys = []
                each(this.templateTasks, t => {
                    each(get(t, 'propertyValues', {}), (pv, pk) => {
                        const pt = this.$store.getters.propertyTypeByKey(pk)
                        const systags = get(pt, 'settings.systags', {})
                        each(args, s => {
                            if (get(systags, s, false)) {
                                assigneeKeys.push(pk)
                            }
                        })
                    })
                })
                return uniq(assigneeKeys)
            }
        },
    },
    mounted() {
        this.templateId = get(this.$route.params, 'id')
        this.data = this.template
        each(get(this.template, 'propertyValues', {}), (pv, pk, propertyValues) => {
            const pt = this.$store.getters.propertyTypeByKey(pk)
            const systags = get(pt, 'settings.systags', {})
            if (get(systags, 'creationTimestamp', false)) {
                this.changeList.push([pt.name, `hodnota vymazána, bude nastaveno automaticky při vytvoření.`])
                delete propertyValues[pk]
            }
            if (get(systags, 'author', false)) {
                this.changeList.push([pt.name, `hodnota vymazána, bude nastaveno automaticky při vytvoření.`])
                delete propertyValues[pk]
            }
            if (get(systags, 'entityState', false)) {
                this.changeList.push([pt.name, `workflow nastaveno do výchozí hodnoty.`])
                delete propertyValues[pk]
            }
        })
    },
    methods: {
        fillTeamToTasks() {
            const propertyValues = get(this.data, 'propertyValues', {})
            each(this.taskKeysForSystag('assignee'), pk => {
                each(this.tasks, t => {
                    this.$set(this.overrides, `${t.id}-${pk}`, get(propertyValues, pk))
                })
            })
        },
        timeTodayPlusOffset() {
            const startDates = []
            each(this.taskKeysForSystag('startTime'), pk => {
                each(this.tasks, t => {
                    const tm = get(t, `propertyValues.${pk}.value.value`)
                    startDates.push(tm)
                })
            })
            const minDate = min(startDates)
            const offsetMs = ((Date.now() / 1000) - minDate) + (this.offsetDays * 24 * 3600 + this.offsetHours * 3600)

            each(this.taskKeysForSystag('startTime', 'endTime'), pk => {
                each(this.tasks, t => {
                    const oldTimestamp = get(t, `propertyValues.${pk}.value.value`, 0)
                    this.$set(this.overrides, `${t.id}-${pk}`, { value: { value: (oldTimestamp + offsetMs) } })
                })
            })
        },
        resetOverrides() {
            this.$set(this, 'overrides', {})
        },
        resetTasksWorkflow() {
            each(this.taskKeysForSystag('entityState'), pk => {
                each(this.tasks, t => {
                    console.info(t, this.$store.getters.taskById(t.id))
                    // const oldWFValue = get(t, `propertyValues.${pk}.value.value`, 0)
                    // console.info(oldWFValue, pk)
                    this.$set(this.overrides, `${t.id}-${pk}`, null)
                    // this.$set(this.overrides, `${t.id}-${pk}`, { value: { value: (oldTimestamp + offsetMs) } })
                })
            })
        },
        async createProject() {
            const tasks = map(cloneDeep(this.tasks), t => {
                const task = cloneDeep(this.$store.getters.taskById(t.id))
                task.id = uuid.v4()
                task.propertyValues = mapValues(task.propertyValues, (pv, pk) => get(t.propertyValues, pk, pv))
                return task
            })
            console.info(tasks)

            try {
                const newId = await this.$store.dispatch('createProjectFromTemplate', { project: this.data, tasks })
                await this.$store.dispatch('projectsLoad')
                await this.$store.dispatch('tasksLoad')

                this.flash('Vytvořeno', 'success', {
                    timeout: 1500,
                })
                this.$router.push({ name: 'projectsDetail', params: { id: newId } })
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.tab-content {
    padding: 10px;
    border-left: 1px solid var(--color-primary);
    border-right: 1px solid var(--color-primary);
    border-bottom: 1px solid var(--color-primary);
}
</style>
